import { styled } from "@linaria/react";
import Button from "@components/_Revamp/Button";
import { Tooltip } from "@pages/CCP/components/Tooltip";
import { ROUTE_PATH } from "@static/route-paths";
import { SCREEN_SIZE } from "@static/screen-size";
import React, { useEffect, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";
import HealthMainContainer from "@components/_Revamp/HealthMainContainer";
import { css } from "@linaria/core";
import InnerContainer from "@components/_Revamp/InnerContainer";
import { useAvivaSelector } from "@redux/hook";
import { useDispatch } from "react-redux";
import FlatButton from "@pages/CCP/components/FlatButton";
import { updateUnderWriting1 } from "@redux/slices/CCP/step3Slice";
import ErrorModal from "@pages/CCP/components/Modals/ErrorModal";
import { trackOnCTA, trackOnLoad } from "@pages/CCP/Helpers/analyticsHelper";
import { CCP_STEP_LIST } from "@static/content";
import { ContainerWithStepper } from "@pages/CCP/components/ContainerWithStepper";

const textItemsSelf = [
  {
    text: "Barrett's Oesophagus",
    tooltipContent: (
      <div>
        <p>
          A metaplastic change of the lining of oesophagus, often caused by
          chronic reflux of stomach acid into the oesophagus. Barrett's
          Oesophagus may be a premalignant condition.
        </p>
        <br />
        <p>Related terms:</p>
        <p>- Barrett's metaplasia</p>
        <p>- Columnar-lined oesophagus</p>
      </div>
    ),
  },
  {
    text: "Cancer",
  },
  {
    text: "Carcinoma in situ of any kind",
  },
  {
    text: "Liver Cirrhosis",
    title: (
      <span
        style={{
          textUnderlineOffset: "5px",
          textDecorationStyle: "dotted",
          textDecorationLine: "underline",
          fontWeight: 600,
        }}
      >
        Cirrhosis
      </span>
    ),
    tooltipContent: (
      <div>
        Liver is scarred, hardened, and permanently damaged. Scar tissue
        replaces normal liver tissue and prevents the liver from working
        normally.
      </div>
    ),
  },
  {
    text: "Crohn's Disease",
    tooltipContent: (
      <div>
        An Inflammatory Bowel Disease (IBD) or long-term inflammation involving
        any part of the digestive tract. The most commonly affected parts are
        the small and large intestines.
      </div>
    ),
  },
  {
    text: "Hepatitis B (other than healthy carriers*)",
  },
  {
    text: "Hepatitis C",
  },
  {
    text: "HIV/AIDS",
  },
  {
    text: "Liver disease due to alcohol",
  },
  {
    text: "Ulcerative Colitis",
    tooltipContent: (
      <div>
        <p>
          An inflammatory bowel disease (IBD) that causes long-term inflammation
          and sores (ulcers) primarily in the lining of the large intestine
          (colon) and rectum.
        </p>
        <br />
        <p>Related terms:</p>
        <p>- Colitis</p>
        <p>- Toxic megacolon</p>
        <p>- Ulcerative proctitis</p>
      </div>
    ),
  },
];

const textItemsChild = [
  {
    text: "Barrett's Oesophagus",
    tooltipContent: (
      <div>
        <p>
          A metaplastic change of the lining of oesophagus, often caused by
          chronic reflux of stomach acid into the oesophagus. Barrett's
          Oesophagus may be a premalignant condition.
        </p>
        <br />
        <p>Related terms:</p>
        <p>- Barrett's metaplasia</p>
        <p>- Columnar-lined oesophagus</p>
      </div>
    ),
  },
  {
    text: "Cancer",
  },
  {
    text: "Carcinoma in situ of any kind",
  },
  {
    text: "Liver Cirrhosis",
    title: (
      <span
        style={{
          textUnderlineOffset: "5px",
          textDecorationStyle: "dotted",
          textDecorationLine: "underline",
          fontWeight: 600,
        }}
      >
        Cirrhosis
      </span>
    ),
    tooltipContent: (
      <div>
        Liver is scarred, hardened, and permanently damaged. Scar tissue
        replaces normal liver tissue and prevents the liver from working
        normally.
      </div>
    ),
  },
  {
    text: "Crohn's disease",
    tooltipContent: (
      <div>
        An Inflammatory bowel disease (IBD) or long-term inflammation involving
        any part of the digestive tract. The most commonly affected parts are
        the small and large intestines.
      </div>
    ),
  },
  {
    text: "Hepatitis B (other than healthy carriers*)",
  },
  {
    text: "Hepatitis C",
  },
  {
    text: "HIV/AIDS",
  },
  {
    text: "Liver disease due to alcohol",
  },
  {
    text: "Ulcerative Colitis",
    tooltipContent: (
      <div>
        <p>
          An inflammatory bowel disease (IBD) that causes long-term inflammation
          and sores (ulcers) primarily in the lining of the large intestine
          (colon) and rectum.
        </p>
        <br />
        <p>Related terms:</p>
        <p>- Colitis</p>
        <p>- Toxic megacolon</p>
        <p>- Ulcerative proctitis</p>
      </div>
    ),
  },
];

function UnderWriting1a() {
  const history = useHistory();
  const isMedication = useAvivaSelector(
    (state) => state.cancerCoverStep3.underWriting1.isMedication
  );
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState<boolean>();
  const basicInfo = useAvivaSelector(
    (state) => state.cancerCoverStep1.basicInfo
  );
  const textItems = useMemo(() => {
    return basicInfo?.forwhom === "myself" ? textItemsSelf : textItemsChild;
  }, [basicInfo?.forwhom]);

  //AA Page Loading
  useEffect(() => {
    trackOnLoad();
  }, []);

  return (
    <>
      <ContainerWithStepper
        currentStep={ROUTE_PATH.CANCER_COVER_UW_1A}
        backButtonPath={ROUTE_PATH.CANCER_COVER_QUOTATION_SUMMARY}
      >
        <InnerContainer className={underwritingContainerStyle}>
          <section className="quoteheader">
            <section className={premiumContainer}>
              <p>
                {basicInfo?.forwhom === "myself"
                  ? "Have you ever had, or are you currently under investigation for:"
                  : "Has your child ever had, or are they currently under investigation for:"}
              </p>
            </section>
          </section>
          <section className="quotecontent">
            {/* <BulletListing bulletList={textItems} rowGap={16} /> */}
            {textItems.map((item) => {
              return (
                <p key={item.text} className="content-title">
                  <span>&#183;</span>
                  {item.tooltipContent ? (
                    <Tooltip
                      title={item.text}
                      isFixed={true}
                      inlineComponent={(item as any).title}
                    >
                      {item.tooltipContent}
                    </Tooltip>
                  ) : (
                    <p>{item.text}</p>
                  )}
                </p>
              );
            })}
          </section>
          <section className="subHeader">
            <p>
              *Never been on medication and liver function is normal in the last
              12 months
            </p>
          </section>
          <section className="actionContainer">
            <FlatButton
              onClick={() => {
                dispatch(updateUnderWriting1({ isMedication: "YES" }));
              }}
              maxWidth="100%"
              isActive={isMedication === "YES"}
              className="flatBtn"
            >
              Yes, at least one
            </FlatButton>
            <FlatButton
              onClick={() => {
                dispatch(updateUnderWriting1({ isMedication: "NO" }));
              }}
              maxWidth="100%"
              isActive={isMedication === "NO"}
              className="flatBtn"
            >
              No, none of the above
            </FlatButton>
          </section>
        </InnerContainer>
        <ButtonContianer>
          <Button
            variant="default"
            label="Next"
            onClick={() => {
              if (isMedication === "YES") setOpenModal(true);
              else {
                //go to next page
                history.push(ROUTE_PATH.CANCER_COVER_UW_1B);
                trackOnCTA({ ctaText: "Next", ctaType: "qb:link" });
              }
            }}
            fontSize="16px"
            disabled={isMedication === null}
          />
        </ButtonContianer>
      </ContainerWithStepper>
      {openModal && (
        <ErrorModal
          title="You may need some assistance"
          error="It looks like you might need assistance from a Financial Adviser Representative
              to find a more suitable plan for your needs."
          onCloseFn={() => setOpenModal(false)}
        />
      )}
    </>
  );
}

export default UnderWriting1a;

const underwritingContainerStyle = css`
  padding: 24px;
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    padding: 24px 64px 24px 64px;
  }
  .quoteheader {
    p {
      font-size: 18px;
      font-weight: 600;
      line-height: 25.2px;
      letter-spacing: 0.015em;
      text-align: left;
      margin-bottom: 36px;
    }
  }
  .subHeader {
    margin: 24px 0;
    p {
      font-size: 12px;
      font-weight: 600;
      line-height: 16.8px;
      letter-spacing: 0.015em;
      text-align: left;
      color: #8a8988;
      @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
        font-weight: 500;
      }
    }
  }
  .quotecontent {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 16px;
    justify-content: space-between;
    .content-title {
      font-size: 14px;
      font-weight: 500;
      width: 100%;
      display: flex;
      span {
        margin-right: 8px;
      }
      @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
        width: 45%;
      }
    }
  }
  .actionContainer {
    display: flex;
    gap: 12px;
    flex-direction: column;
    @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
      flex-direction: row;
      gap: 8px;
    }
    .flatBtn {
      font-size: 14px;
      @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
        font-size: 12px;
      }
    }
  }
`;

const premiumContainer = css`
  display: flex;
  font-size: 28px;
  font-weight: 600;
  justify-content: space-between;
  line-height: 39.2px;

  p {
    font-size: 18px;
    letter-spacing: 0.27px;
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    p {
      font-size: 28px;
    }
  }
`;

const ButtonContianer = styled.div`
  margin: auto;
  margin-top: 50px;
  width: 100%;
  max-width: 288px;
`;
